import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowDatePickerToolbar } from './datepickertoolbar.theme';

export const flowDateTimePickerToolbar: Components<Theme>['MuiDateTimePickerToolbar'] = {
  ...(flowDatePickerToolbar as Components<Theme>['MuiDateTimePickerToolbar']),
};
